import React from "react";
import { css } from "styled-components";

import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import {
  DealerBenefitsSection,
  StyledP2,
  DealerBenefitsList,
  DealerBenefitsItem,
  Title,
} from "../styles";

export const DealerBenefits = () => (
  <DealerBenefitsSection>
    <StyledP2>
      {
        "Savant Power dealer credentials grant your business access to the entire catalogue of Savant Power products and services including:"
      }
    </StyledP2>
    <DealerBenefitsList>
      <DealerBenefitsItem>
        <Title>{"Detailed System Design"}</Title>
        <StyledP2>
          {"Full detailed system design from our engineering team"}
        </StyledP2>
      </DealerBenefitsItem>
      <DealerBenefitsItem>
        <Title>{"System Quoting"}</Title>
        <StyledP2>
          {"Including 25-year cash flow and tax credits/incentives"}
        </StyledP2>
      </DealerBenefitsItem>
      <DealerBenefitsItem>
        <Title>{"Documentation"}</Title>
        <StyledP2>{"Local permitting"}</StyledP2>
      </DealerBenefitsItem>
      <DealerBenefitsItem>
        <Title>{"Utility Interconnection Approval"}</Title>
        <StyledP2>{"Project management"}</StyledP2>
      </DealerBenefitsItem>
      <StyledP2
        css={css`
          margin: 24px 0px 34px 0px;
          @media screen and (min-width: ${getSize("mobile480")}) {
            margin: 24px 0px 54px 0px;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            margin: 24px 0px 42px 0px;
          }
        `}
      >
        {
          "For added value to your clients, Savant Power certification includes access to a wide breadth of Savant smart home automation control solutions."
        }
      </StyledP2>
    </DealerBenefitsList>
  </DealerBenefitsSection>
);
